// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"views_desktopOnly__3KdBi","mobileOnly":"views_mobileOnly__bGg_o"};